import { HttpRequestData, httpUtil } from '@esg/framework';
import { getEnv } from '@esg/shared';

interface GetDetailBranchRequest extends HttpRequestData {
    readonly pathData: {
        readonly id: string;
    };
}

export enum SocialType {
    Youtube = 1,
    GoogleMap = 2,
    Facebook = 3,
    Instagram = 4
}
export interface IWorkingTimeItem {
    readonly id?: string;
    readonly isDayOff: boolean;
    readonly startTime: string;
    readonly endTime: string;
    readonly openTime: string;
    readonly closeTime: string;
    readonly dayOfWeek: number;
    readonly dayOfWeekTitle: string;
    readonly breakTimes?: IBreakTimes[];
}

export interface IBreakTimes {
    readonly id?: string;
    readonly startTime: string;
    readonly endTime: string;
    readonly dayOfWeek: number;
    readonly dayOfWeekTitle: string;
    readonly isFixed?: boolean;
    readonly employeeId?: string;
    readonly shiftId?: string;
    readonly businessHourId?: string;
}


export interface BranchSocialLinkInfo {
    readonly branchId: string;
    readonly type: SocialType;
    readonly value: string;
}
export interface GetDetailBranchResponseItem {
    readonly id: string;
    readonly name: string;
    readonly logo?: string;
    readonly countryCode?: string;
    readonly taxCode?: string;
    readonly phoneNumber?: string;
    readonly currency?: string;
    readonly tax?: string;
    readonly dateTimeFormat?: string;
    readonly timezone?: string;
    readonly languages?: string;
    readonly address: string;
    readonly city: string;
    readonly state: string;
    readonly postalCode: string;
    readonly country: string;
    readonly businessHour: IWorkingTimeItem[];
    readonly socialLinks: BranchSocialLinkInfo[];
}

export const getDetailBranch = httpUtil.createHttpRequestMeta<
    GetDetailBranchRequest,
    GetDetailBranchResponseItem
>({
    baseUrl: () => getEnv().MANAGEMENT_SERVER,
    method: 'GET',
    path: '/api/v1/branches/:id',
    authentication: 'bearer',
});